import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeMode = 'dark' | 'light';

type AppThemeStoreType = {
  themeMode: ThemeMode;
};

type AppThemeStoreActions = {
  setThemeMode: (themeMode: ThemeMode) => void;
  toggleThemeMode: () => void;
};

const initialState: AppThemeStoreType = {
  themeMode: 'light'
};

export const useAppThemeStore = create<AppThemeStoreType & AppThemeStoreActions>()(
  persist(
    set => ({
      ...initialState,
      setThemeMode: themeMode => set({ themeMode }),
      toggleThemeMode: () =>
        set(state => ({
          themeMode: state.themeMode === 'dark' ? 'light' : 'dark'
        }))
    }),
    {
      name: 'app-theme-store',
      version: 2
    }
  )
);

export const useIsDarkMode = () => useAppThemeStore(state => state.themeMode) === 'dark';
